import React from 'react';
import { ShimmerBox } from '../PageSkeleton/PageSkeleton';

const NAME_W = ['62%', '48%', '70%', '55%', '75%', '50%'];
const ROLE_W = ['52%', '65%', '45%', '60%', '48%', '68%'];

const TeamSkeleton: React.FC = () => (
    <div className="flex flex-col gap-2 pb-4 animate-fade-in-up">

        {/* Desktop header — matches MembersView COLS_DESKTOP grid */}
        <div
            className="hidden lg:grid gap-4 px-5 py-3 text-[11px] font-black uppercase tracking-widest"
            style={{
                gridTemplateColumns: '56px 1fr minmax(160px,220px)',
                color: 'var(--v2-text-muted)',
            }}
        >
            <div />
            <ShimmerBox className="h-3 w-16 rounded" delay="0s" />
            <ShimmerBox className="h-3 w-10 rounded" delay="0.05s" />
        </div>

        {/* Shimmer rows — 6 rows, desktop + mobile */}
        {Array.from({ length: 6 }).map((_, i) => (
            <div
                key={i}
                className="rounded-xl overflow-hidden"
                style={{
                    background: 'var(--v2-bg-card)',
                    border: '1px solid var(--v2-border-card)',
                    borderLeft: '3px solid var(--v2-skeleton-base)',
                }}
            >
                {/* Desktop shimmer — 3 columns: avatar | name+email | role */}
                <div
                    className="pl-6 pr-4 py-3.5 hidden lg:grid gap-4 items-center"
                    style={{ gridTemplateColumns: '56px 1fr minmax(160px,220px)' }}
                >
                    <ShimmerBox className="w-10 h-10 rounded-full" delay={`${i * 0.04}s`} />
                    <div className="space-y-2">
                        <ShimmerBox className="h-4 rounded" style={{ width: NAME_W[i] }} delay={`${i * 0.04}s`} />
                        <ShimmerBox className="h-3 w-1/2 rounded" delay={`${i * 0.04 + 0.02}s`} />
                    </div>
                    <ShimmerBox className="h-7 rounded-full" style={{ width: ROLE_W[i] }} delay={`${i * 0.04 + 0.04}s`} />
                </div>

                {/* Mobile shimmer — avatar + stacked name/email */}
                <div className="px-4 py-3.5 lg:hidden flex items-center gap-3">
                    <ShimmerBox className="w-10 h-10 rounded-full flex-shrink-0" delay={`${i * 0.04}s`} />
                    <div className="flex-1 space-y-2">
                        <ShimmerBox className="h-4 w-3/4 rounded" delay={`${i * 0.04}s`} />
                        <ShimmerBox className="h-3 w-1/2 rounded" delay={`${i * 0.04 + 0.02}s`} />
                    </div>
                </div>
            </div>
        ))}
    </div>
);

export default TeamSkeleton;
